export const MAX_TIMEOUT_MS = 2_147_483_647;

export const parseTimerSeconds = (value: string | undefined): number | null => {
  const seconds = Number(value);
  return Number.isFinite(seconds) && seconds > 0 && seconds * 1000 <= MAX_TIMEOUT_MS
    ? seconds : null;
};

export const parseScheduledTime = (config: Record<string, string>): number | null => {
  const { date, time } = config;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date ?? "") ||
      !/^(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d{1,3})?)?$/.test(time ?? "")) return null;
  const parsed = new Date(`${date}T${time}`);
  const [year, month, day] = date.split("-").map(Number);
  const [hours, minutes, seconds = "0"] = time.split(":");
  const [wholeSeconds, milliseconds = ""] = seconds.split(".");
  if (!Number.isFinite(parsed.getTime()) || parsed.getFullYear() !== year ||
      parsed.getMonth() !== month - 1 || parsed.getDate() !== day ||
      parsed.getHours() !== Number(hours) || parsed.getMinutes() !== Number(minutes) ||
      parsed.getSeconds() !== Number(wholeSeconds) ||
      parsed.getMilliseconds() !== Number(milliseconds.padEnd(3, "0"))) return null;
  return parsed.getTime();
};
